import styled from 'styled-components'
import { print } from 'utilities/styled'
import MasonryBase from 'react-responsive-masonry'
import { Container } from 'components/charts/s'

export const Masonry = styled(MasonryBase)`
    > div {
        & > div:empty {
            display: none;
        }

        ${print`
            & {
                width: 100% !important;
            }
        `}
    }

    ${Container} {
        width: 100%;
    }
`